import React from "react";

import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class Category extends React.Component {
  render() {
    const { language, min_order, settings } = this.props;
    // let min_order_text = min_order
    //   ? language === "english"
    //     ? `( Min Order ${min_order} ${settings?.currency_english} )`
    //     : `( الحد الأدنى ${min_order} ${settings?.currency_local} )`
    //   : null;
    const currencyIcon = getCurrencyIcon(settings)
    let min_order_text = min_order ? (
      language === "english" ? (
        <span>
          {"( Min Order "}
          <span className={currencyIcon}>
            {min_order} {settings?.currency_english}
          </span>
          {" )"}
        </span>
      ) : (
        <span>
          {"( الحد الأدنى "}
          <span className={currencyIcon}>
            {min_order} {settings?.currency_local}
          </span>
          {" )"}
        </span>
      )
    ) : null;

    return (
      <div
        className={"category_menu my-auto "}
        style={this.props.style}
        onClick={() => {
          this.props.onClick(this.props.id);
        }}
        id={this.props.id}
      >
        <h5
          className={language == "arabic" && "text-right"}
          style={{ fontFamily: language == "english" ? "Quicksand" : "Cairo" }}
        >
          {this.props.text} {min_order_text ? min_order_text : ""}
          <span
            className={`${
              language === "english" ? "float-right" : "float-left"
            }`}
          >
            <MoreHorizIcon />
          </span>
        </h5>
      </div>
    );
  }
}

export default Category;
